require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./javascript-algorithms-and-data-structures-basic-data-structures-create-complex-multi-dimensional-arrays.json") })
        }
      }, "path---javascript-algorithms-and-data-structures-basic-data-structures-create-complex-multi-dimensional-arrays");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---javascript-algorithms-and-data-structures-basic-data-structures-create-complex-multi-dimensional-arrays!./.cache/json/javascript-algorithms-and-data-structures-basic-data-structures-create-complex-multi-dimensional-arrays.json
// module id = 2239
// module chunks = 231608221292675